module.exports = __webpack_public_path__ + "static/MADE_Evolve_Sans_Medium-4000a4be138eaf65b489213a29e027f0.woff";